export default __webpack_public_path__ + "static/media/Totem.5b889eb3.jpg";